import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import LanguageContent from './LanguageContent'
import UserContent from './UserContent'
export default class User extends React.Component {
    
    render() {
    let id = this.props.match.params.id;
       
        return (
            <div class="wrapper">

                <div class="preloader hide flex-column justify-content-center align-items-center">
                    <img class="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60" />
                </div>
                <Navbar />
                <Mainmenu />
                <UserContent id={id} />
                <Footer /> 

            </div>


        )
    }
}
